import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import useTheme from "@mui/material/styles/useTheme";

import CircularProgress from "components/circular-progress";
import { DRAWER_WIDTH } from "features/patients/patient-drawer";

import CallLogContent from "./call-log-content.component";
import { useCallLogDrawer } from "./use-call-log-drawer";

export default function CallLogDrawer() {
  const theme = useTheme();
  const { isOpen, isFetching, callLog, handleClose } = useCallLogDrawer();

  return (
    <Drawer
      PaperProps={{
        sx: {
          width: DRAWER_WIDTH
          // overflow: "hidden",
        }
      }}
      variant="persistent"
      anchor="right"
      sx={{
        zIndex: theme.zIndex.snackbar
      }}
      open={isOpen}
      onClose={handleClose}
    >
      {isFetching && <CircularProgress sx={{ width: "100%" }} />}
      {!isFetching && callLog && (
        <>
          <Box
            display="flex"
            justifyContent="end"
            position="absolute"
            width="100%"
          >
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box pt={4}>
            <CallLogContent />
          </Box>
        </>
      )}
    </Drawer>
  );
}
